import React from "react";
import ReactDOM from "react-dom";
import { DataTable } from "react-datatable-bs";
require("react-datatable-bs/css/table-twbs.css");
/* eslint-disable react/prop-types */

export default class TableComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { key: 0 };
  }
  // react-datatable-bs re-runs dataLoaded on EVERY prop update, which drops the
  // active filter (rows reset, the input keeps its text). Moving/selecting the
  // box re-renders the parent, so only pass through real content changes.
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.key !== this.state.key ||
      JSON.stringify([nextProps.data, nextProps.keys, nextProps.options]) !==
        JSON.stringify([this.props.data, this.props.keys, this.props.options])
    );
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.options &&
      nextProps.options.initialPageLength &&
      this.props.options &&
      this.props.options.initialPageLength &&
      this.props.options.initialPageLength !== nextProps.options.initialPageLength
    ) {
      this.setState({ key: this.state.key + 1 });
    }
  }
  render() {
    let data = this.props.data;
    // Copy: the pageLengthOptions writes below must not mutate redux state.
    let options = { ...this.props.options };
    let realKeys = this.props.keys;
    let cols = [];
    realKeys.forEach((key, i) => {
      cols.push({ title: key, prop: i });
    });

    // Sizes below the row count, plus the first one that shows every row
    // (6 rows → 5, 10). Filtering to `<= length` left a lone "5".
    const sizes = [5, 10, 25, 50, 100];
    const fitAll = sizes.findIndex((a) => a >= data.length);
    options.pageLengthOptions = fitAll === -1 ? sizes : sizes.slice(0, fitAll + 1);
    if (
      !isNaN(options.initialPageLength) &&
      options.pageLengthOptions.indexOf(options.initialPageLength) === -1
    ) {
      options.pageLengthOptions = this.insert(options.initialPageLength, options.pageLengthOptions);
    }
    // sortColumn (resolveOptions) is a column index, -1 = no initial sort;
    // legacy callers still pass initialSort as a header value.
    let prop =
      options.sortColumn !== undefined
        ? options.sortColumn
        : realKeys.indexOf(options.initialSort) !== -1
          ? realKeys.indexOf(options.initialSort)
          : 0;
    return (
      <div
        className={
          "tableContainer theme-" +
          options.theme +
          (options.transparentBg ? " tableContainer--transparent" : "")
        }
      >
        <DataTable
          key={this.state.key || 0}
          keys="name"
          columns={cols}
          initialData={data}
          initialPageLength={options.initialPageLength || 5}
          disablePagination={options.disablePagination}
          disableFilter={options.disableFilter}
          disableRowChoice={options.disableRowChoice}
          pageSizeLabel={options.pageSizeLabel}
          noDataLabel={options.noDataLabel}
          searchLabel={options.searchLabel}
          searchPlaceholder={options.searchPlaceholder}
          pageLengthOptions={options.pageLengthOptions}
          paginationBottom
          initialSortBy={prop === -1 ? undefined : { prop: prop, order: options.initialOrder }}
        />
      </div>
    );
  }
  insert(element, array) {
    array.splice(this.locationOf(element, array) + 1, 0, element);
    return array;
  }

  locationOf(element, array, start, end) {
    start = start || 0;
    end = end || array.length;
    let pivot = parseInt(start + (end - start) / 2, 10);
    if (end - start <= 1 || array[pivot] === element) {
      return pivot;
    }
    if (array[pivot] < element) {
      return this.locationOf(element, array, pivot, end);
    }
    return this.locationOf(element, array, start, pivot);
  }
  componentDidUpdate() {}
  componentDidMount() {}
}
/* eslint-enable react/prop-types */
